import React from 'react'
import { Controller, ControllerProps, ControllerRenderProps, FieldValues, Path } from 'react-hook-form'

import { FormGroup } from './styles'

type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'defaultChecked' | 'checked'>

interface Props<TFieldValues extends FieldValues = FieldValues, TName extends Path<TFieldValues> = Path<TFieldValues>>
    extends Omit<ControllerProps<TFieldValues, TName>, 'render'> {
    label?: string
    groupStyle?: React.CSSProperties

    inputProps?: InputProps
}

// eslint-disable-next-line prettier/prettier, max-len
export function Input<TFieldValues extends FieldValues, TName extends Path<TFieldValues>>({
    name,
    control,
    rules,
    label,
    groupStyle,

    defaultValue,
    shouldUnregister,
    inputProps
}: Props<TFieldValues, TName>): JSX.Element {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={defaultValue}
            shouldUnregister={shouldUnregister}
            render={({ field, fieldState }) => {
                return (
                    <FormGroup validationState={fieldState.error ? 'error' : 'success'} style={groupStyle}>
                        {label && <label className="control-label">{label}</label>}
                        <input {...field} {...inputProps} className="form-control" />
                    </FormGroup>
                )
            }}
        />
    )
}
